<template>
  <el-dialog
            title="批量导入"
            :visible="true"
            width="50%"
            :append-to-body=true
           
            :before-close="handleClose">
   <div>
        <div class="title">成功导入{{table.total_success}}条,失败{{table.total_failure}}条</div>
       <div class="tableBox" v-loading="loading">
            <table class="table table-striped table-bordered table-hover">
                <thead>
                <tr>
                    <th style="width: 40px;">出货时间</th>
                    <th style="width: 140px">出货单号</th>
                    <th style="width: 120px">经销商/门店编号</th>
                    <th style="width: 220px">经销商/门店名称</th>
                    <th style="width: 120px" v-if='table.is_nsb==0'>出货仓库</th>
                    <th style="width: 120px" v-if='table.is_nsb==0'>收货地址</th>
                    <th style="width: 120px">是否赠品</th>
                    <th style="width: 120px">商品编号</th>
                    <th style="width: 120px">商品名称</th>
                    <th style="width: 120px">商品批次号</th>
                    <th style="width: 160px">实发数量</th>
                    <th style="width: 160px">备注</th>
                    <th style="width: 180px" v-if='table.is_nsb==1'>商品规格</th>
                    <th style="width: 120px" v-if='table.is_nsb==1'>商品单位</th>
                    <th style="width: 120px" v-if='table.is_nsb==1'>商品条码</th>
                    <th style="width: 200px" v-if='table.is_nsb==1'>生产日期</th>
                    <th style="width: 120px" v-if='table.is_nsb==1'>有效期</th>
                    <th style="width: 180px" v-if='table.is_nsb==1'>品牌名称</th>
                    <!-- <th style="width: 180px" v-if='table.is_nsb==1'>收货地址</th> -->
                    <th style="width: 200px;">失败原因</th>
                </tr>
                </thead>
                <tbody>
                <template v-for="(item,index) in table.failure_data">
                    <template v-for="(val,num) in item.products">
                        <tr>
                            <template v-if="item.products.length > 0 && num > 0">
                                <td colspan="7" v-if='table.is_nsb==0'></td>
                                <td colspan="5" v-if='table.is_nsb==1'></td>
                            </template>
                            <template v-else>
                                <td style="white-space: nowrap;">{{item.stock_out_time}}</td>
                                <td style="white-space: nowrap;">{{item.stock_out_sn}}</td>
                                <td style="white-space: nowrap;">{{item.to_sn}}</td>
                                <td style="white-space: nowrap;">{{item.to_name}}</td>
                                <td style="white-space: nowrap;" v-if='table.is_nsb==0'>{{item.warehouse_name}}</td>
                                <td style="white-space: nowrap;" v-if='table.is_nsb==0'>{{item.to_address}}</td>
                                <td>
                                    <span v-if="item.isgift == 1">赠品</span>
                                    <span v-else>非赠品</span>
                                </td>
                            </template>
                            <td style="white-space: nowrap;">{{val.product_sn}}</td>
                            <td style="white-space: nowrap;">{{val.product_name}}</td>
                            <td style="white-space: nowrap;">{{val.production_batch}}</td>
                            <td style="white-space: nowrap;">{{val.real_stock_out_num}}</td>
                            <td style="white-space: nowrap;">{{val.remarks}}</td>
                            <td style="white-space: nowrap;" v-if='table.is_nsb==1'>{{val.product_specs}}</td>
                            <td style="white-space: nowrap;" v-if='table.is_nsb==1'>{{val.product_unit}}</td>
                            <td style="white-space: nowrap;" v-if='table.is_nsb==1'>{{val.product_bar_code}}</td>
                            <td style="white-space: nowrap;" v-if='table.is_nsb==1'>{{val.production_date}}</td>
                            <td style="white-space: nowrap;" v-if='table.is_nsb==1'>{{val.expiring_date}}</td>
                            <td style="white-space: nowrap;" v-if='table.is_nsb==1'>{{val.brand_name}}</td>
                            <td style="white-space: nowrap;">
                               {{item.error_msg}}
                            </td>
                        </tr>
                    </template>
                </template>

                </tbody>
            </table>
        </div>
  <el-button type="primary" @click='done()'>完成</el-button>
  
   </div>
  </el-dialog>
</template>
<script>
export default {
    name:'importDetail',
    data(){
        return{
          
        }
    },
    methods:{
        done(){

             this.$emit('refresh');
        },
        handleClose(){
             this.$emit('handleClose');

        }
    },
    props:{
        table:Object
    },
    created(){
        
        console.log(this.table)
    }
}
</script>

<style lang="scss" scoped>
/deep/.cell {
    height: auto;
// overflow: visible;


img{
    height:100px;
}
} 
/deep/ .price >div{
    text-align: left;
}
/deep/.el-form--inline .el-form-item{
    margin-right: 15px;
}
/deep/table{
    overflow-y: scroll;
  tbody  tr{
        height: 200px;
    }
} 
   .tableBox {
        overflow-x: scroll;
        .table {
            width: 300%;
        }
    }
</style>


